import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { sweetAlert, sweetAlertWithHtml } from '../../../utils/swal';
import * as _ from 'underscore';
import * as moment from 'moment-timezone';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { AssigTripsService } from '../assigntrips-service/assigntrips-service';
import { DispatchCenterService } from '../../dashboard/dashboard-service/dispatch-center-service';
import { downloadFile } from 'src/app/utils/pdf-downloader';
import { urls } from 'src/app/utils/url-utils';
import { MenuService, UserRoles } from '../../shared/layout/menu-service/menu.service';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { Cms1500Service } from 'src/app/service/cms-service/cms1500.service';
import { CsvService } from 'src/app/service/csv-service/csv.service';
import { ToastrService } from 'ngx-toastr';
import { ReportService } from '../../reports/reports-service/report.service';
import { FilterByKeyPipe } from 'src/app/pipe/list-filterbykey-pipe/list-filterbykey-pipe';
import { FilterPipe } from 'src/app/pipe/list-filter-pipe/list-filter-pipe';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
import { ServiceAreasService } from '../../service-areas/service-areas-service/service-areas.service';
import { environment } from 'src/environments/environment';
import { StaffService } from '../../staffs/staff-service/staff.service';
import { exit } from 'process';
import { checkRole, parseDisplayName } from 'src/app/utils/utils.common';
import { AssistService } from 'src/app/service/assist-service/assist.service';
import { ClassGetter } from '@angular/compiler/src/output/output_ast';
import { FleetService } from '../../fleet/fleet-service/fleet.service';
import { ZonesService } from '../../zones/zones-service/zones.service';
import { PayorService } from 'src/app/service/payor/payor.service';
import { TranslationService } from 'src/app/service/translation-service/translation.service';
@Component({
  selector: "app-unassigned",
  templateUrl: "./unassigned.component.html",
  styleUrls: ["./unassigned.component.css"],
})
export class UnassignedComponent implements OnInit, OnDestroy {
  @ViewChild("timer", { static: false }) timer;
  duration = 10 * 1000; // 10 seconds
  dataList = [];
  subMenus = [];
  filterdataList = [];
  todayDate = [
    moment.tz("America/New_York").startOf("day").toISOString(),
    moment.tz("America/New_York").endOf("day").toISOString(),
  ];
  status = "";
  isShowAllTrips = false;
  showSlideFilter = false;
  isTimerEnabled = false;
  search: any;
  assignModalObj;
  companyAssignModalObj;
  componentType;
  tripIndex = -1;
  sweepTripsList = null;
  timeZone;
  settingInterval;
  secondaryCompType = null;
  specialRate;
  user;
  cancelTripModalObj;
  pullBackFarmoutModalObj;
  selectedTrip;
  billerNoteModalObj;
  additionalNoteModalObj;
  tripLogObj;
  checkListObj;
  aiAssistantConversationObj;
  selectedTrips = [];
  orderBy = "scheduleTime";
  toggleActionButtons: boolean = false;
  view = "grid";
  selectedDropdownIndex: any;
  tripDetailModalObj;
  completedTripModalObj;
  skip = 0;
  editTripModalObj;
  selectedTripId;
  isAllTripsSelected: boolean = false;
  isVipMember = false;
  isManualTrip = false;
  isMissingLOS = false;
  isMissingAppointmentType = false;
  isMissingAppointmentTime = false;
  isMissingAddress = false;
  isMissingPhone = false;
  isDuplicateAddress = false;
  isDuplicateTrip = false;
  isShowCms1500 = false;
  associateImageModalObj;
  partialEditModalObj;

  tripPurposesAndAddons;
  selectedTripPurpose = '';
  selectedLOS = '';
  selectedSpaceType = '';
  appointmentTypes;
  selectedAptType;
  selectedServiceArea = '';
  patients;
  selectedPatient = "";
  drivers;
  selectedDriver = "";
  cooperates;
  selectedCooperate = "";

  preCooperates = {};
  preLevelOfServices = {};
  preSpaceTypes = {};
  preServiceAreas = {};
  corporateList = [];
  filteredCorporates = [];
  serviceAreaList = [];
  filteredServiceAreas = [];
  levelOfServiceList = [];
  filteredLevelOfService = [];
  spaceTypeList = [];
  filteredSpaceTypes = [];

  stationManagerList = [];
  selectedStationManager = [];
  preStaffList = {};
  isAllowRates = false;
  isNoShow = false;
  assists: any;
  preAssistList
  templateSaveModalObj;
  feedbackTrip: any;
  willCallObj;
  isEnabledOneHourException = true;
  showIpcr = false;
  isSmsAllowed = false;
  tripIntakeModalObj;
  preZones;
  payorList:any;
  prePayorsList:any = {};
  isConfirmationCalls = true;
  outBoundNumber:any;
  confirmationCallURL: string = '';
  bulkCallReviewGroups: any = null;

  constructor(
    private assistService: AssistService,
    private reportService: ReportService,
    private cms1500Service: Cms1500Service,
    private assignTripService: AssigTripsService,
    private dispatchCenterService: DispatchCenterService,
    private sharedDataService: SharedDataService,
    private socketService: SocketService,
    private menuService: MenuService,
    private csvService: CsvService,
    private toastr: ToastrService,
    private corporateService: CorporateService,
    private driverService: DriversService,
    private levelOfServiceService: LevelOfServiceService,
    private serviceArea: ServiceAreasService,
    private staffService: StaffService,
    private fleetService: FleetService,
    private zonesService: ZonesService,
    private payorService: PayorService,
    private translationService: TranslationService
  ) { }

  ngOnInit() {
    this.getCorporate();
    this.getLevelOfService();
    this.getSpaceTypes();
    this.getServiceAreas();
    this.listenSocket();
    this.getStaffList();
    this.getAssisData();
    this.getZones();
    this.getPayorList();

    this.translationService.locale$
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(() => {
        this.refreshStatusMenus();
      });
  }

  getZones() {
    this.zonesService.getZones().subscribe(data => {
      this.preZones = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
    });
  }

  setTripStatus(status, isSkipCheck?) {
    if (!isSkipCheck && this.status === status) return;
    this.skip = 0;
    this.clearTrips();
    this.selectedDropdownIndex = -1;
    this.status = status;
    this.getTrips();
    this.reset();
  }

  reset() {
    this.selectedTrips = [];
    this.orderBy = "scheduleTime";
  }

  getCorporate() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.corporateList = data;
          this.preCooperates = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }


  getLevelOfService() {
    this.levelOfServiceService
      .getLevelOfServices({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.levelOfServiceList = data;
          this.preLevelOfServices = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getSpaceTypes() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.spaceTypeList = data;
          this.preSpaceTypes = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
        this.getUser();
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.serviceAreaList = data;
            this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }

  getStaffList() {
    let queryParams = {
      status: 'active'
    }
    this.staffService
      .getStaffList(queryParams)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.preStaffList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }
  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.timeZone = data.timeZone;
          this.user = data;
          // this.todayDate = moment.tz(this.timeZone).startOf('day').toISOString();
          this.todayDate = [
            moment.tz(this.timeZone).startOf("day").toISOString(),
            moment.tz(this.timeZone).endOf("day").toISOString(),
          ];
          
          this.isConfirmationCalls = data.company ? data.company.allowConfirmationCalls : data.allowConfirmationCalls;

           if (this.user.hasOwnProperty("outboundNumber")) {
            this.outBoundNumber = this.user.outboundNumber;
          }
          
          if (this.user.hasOwnProperty("confirmationCallURL") && this.user.confirmationCallURL) {
            this.confirmationCallURL = this.user.confirmationCallURL;
          }

          if (this.user.hasOwnProperty("isListView") && this.user.isListView) {
            this.view = "list";
          }

          if (this.user.hasOwnProperty("isSms") && this.user.isSms) {
            this.isSmsAllowed = this.user.isSms;
          }

          if (this.user.hasOwnProperty("isShowCMS1500")) {
            this.isShowCms1500 = this.user.isShowCMS1500;
          }
          this.isAllowRates = checkRole(this.user);
          if (this.user.hasOwnProperty('hideOneHourException') && this.user.hideOneHourException) {
            this.isEnabledOneHourException = false;
          }
          if (this.user.hasOwnProperty('showIpcr') && this.user.showIpcr) {
            this.showIpcr = true;
          }
          
          this.getStaffRoles();
        }
      });
  }

  getTrips() {
    // this.filterdataList = [];
    // this.dataList = [];
    const object = {
      isShowAllTrips: this.isShowAllTrips,
      status: this.status,
      date: this.todayDate,
      skip: this.skip,
    };
    // this.store.dispatch(new GetUnassignedList(object));
    this.assignTripService
      .getAssignList(object)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (this.skip === 0) {
            this.clearTrips();
          }
          if (data && object.status === this.status) {
            data.forEach((trip) => {
              trip.isWillcall = moment(trip.scheduleTime).tz(this.timeZone).format("HHmm") == '2359';
              this.setTripMissingFlags(trip);
              if (
                this.showIpcr
                && this.preSpaceTypes
                && this.preSpaceTypes[trip.spaceType]
                && this.preSpaceTypes[trip.spaceType].showIpcr
              ) {
                trip.showIpcr = true;
              }
            });
            // this.search = '';
            this.dataList = [...data, ...this.dataList];
            this.filterdataList = this.dataList;
            this.group(true);


            if (data.length) {
              this.skip += data.length;
              this.getTrips();
            } else {
              this.skip = 0;
              if (this.timer && this.status === 'unassigned') {
                if (this.isTimerEnabled)
                  this.timer.start();
              }
              this.drivers = [];
              this.stationManagerList = [];
              let cooperates = [];
              this.tripPurposesAndAddons = [];
              let levelOfServices = [];
              let spaceTypes = [];
              let serviceAreas = [];
              this.appointmentTypes = [];
              this.patients = [];
              this.dataList.forEach(trip => {

                if (trip.driver) {
                  this.drivers.push({ _id: trip.driver._id, displayName: trip.driver.displayName });
                }
                if (trip.driver && trip.driver.stationManager) {
                  this.stationManagerList.push(trip.driver.stationManager);
                }
                if (trip.cooperate) {
                  cooperates.push(trip.cooperate);
                }

                // if (trip.tripReason) {
                //   // remove the item having empty string
                //   const reasons = trip.tripReason.split(',').filter((reason) => reason !== '');
                //   if (reasons && reasons.length) {
                //     this.tripPurposesAndAddons.push(...reasons);
                //   }
                // }

                if (trip.addonServices && trip.addonServices.length) {
                  for (let addon of trip.addonServices) {
                    this.tripPurposesAndAddons.push(addon.title);
                  }
                }

                if (trip.los) {
                  levelOfServices.push(trip.los);
                }

                if (trip.spaceType) {
                  spaceTypes.push(trip.spaceType);
                }

                if (trip.tripReason) {
                  // remove the item having empty string
                  if (trip.tripReason && trip.tripReason.length) {
                    this.appointmentTypes.push(...trip.tripReason);
                  }
                }
                // const zipCode = this.extractZipCode(trip.jobOriginAddress)
                if (trip.serviceArea) {
                  serviceAreas.push(trip.serviceArea);
                }
                if (trip.priorityClient) {
                  this.patients.push({ displayName: trip.priorityClient.displayName });
                }
              });


              if (this.selectedLOS)
                levelOfServices.push(this.selectedLOS)

              if (this.selectedSpaceType)
                spaceTypes.push(this.selectedSpaceType)

              if (this.selectedServiceArea)
                serviceAreas.push(this.selectedServiceArea)

              if (this.selectedAptType)
                this.appointmentTypes.push(this.selectedAptType)

              if (this.selectedPatient)
                this.patients.push(this.selectedPatient)



              this.drivers = _.uniq(this.drivers, '_id').sort();
              this.stationManagerList = _.uniq(this.stationManagerList).sort();
              cooperates = _.uniq(cooperates).sort();
              this.tripPurposesAndAddons = [...new Set(this.tripPurposesAndAddons)].sort();
              levelOfServices = _.uniq(levelOfServices).sort();
              spaceTypes = _.uniq(spaceTypes).sort();
              serviceAreas = _.uniq(serviceAreas).sort();
              this.appointmentTypes = [...new Set(this.appointmentTypes)].sort();
              this.patients = _.uniq(this.patients, 'displayName').sort();

              if (cooperates && cooperates.length) {
                this.filteredCorporates = this.corporateList.filter(c => cooperates.includes(c._id));
              }

              if (levelOfServices && levelOfServices.length) {
                this.filteredLevelOfService = this.levelOfServiceList.filter(l => levelOfServices.includes(l._id));
              }

              if (serviceAreas && serviceAreas.length) {
                this.filteredServiceAreas = this.serviceAreaList.filter(s => serviceAreas.includes(s._id));
              }

              if (spaceTypes && spaceTypes.length) {
                this.filteredSpaceTypes = this.spaceTypeList.filter(s => spaceTypes.includes(s._id));
              }

              if (this.status === 'unassigned') {
                this.selectedDriver = "";
                this.selectedStationManager = [];
              }

              this.setDuplicateTripFlags();
            }
          } else if (this.timer && this.status === 'unassigned') {
            if (this.isTimerEnabled)
              this.timer.start();
          }
          this.filterTripsByModel();
        }, err => {
          sweetAlert('Error', err, 'warning', 'OK');
        });
  }

  clearTrips() {
    this.skip = 0;
    this.filterdataList = [];
    this.dataList = [];
  }

  listenSocket() {
    this.socketService
      .addListener(Events.DROP_TRIP)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data.success) {
          // sweetAlert('Success', data.message, 'success', 'OK');
          const indexOfDataList = _.findIndex(this.dataList, {
            _id: data.assignId,
          });

          if (indexOfDataList > -1) this.dataList.splice(indexOfDataList, 1);

          const indexOfFilterdataList = _.findIndex(this.filterdataList, {
            _id: data.assignId,
          });
          if (indexOfFilterdataList > -1)
            this.filterdataList.splice(indexOfFilterdataList, 1);

          this.setDuplicateTripFlags();
        } else {
          sweetAlert("Error", data.message, "warning", "OK");
        }
      });

    this.socketService
      .addListener(Events.UPDATE_ASSIGN_TRIP)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data.success) {
          // sweetAlert('Success', data.message, 'success', 'OK');
          this.dataList.filter((item) => {
            if (data.assign._id === item._id) {
              item.isReadyForPickup = data.assign.isReadyForPickup;
              item.isVipTrip = data.assign.isVipTrip;
              item.isConfirmedTrip = data.assign.isConfirmedTrip;
              item.isMarkedCancelledTrip = data.assign.isMarkedCancelledTrip;
              item.isVoiceMail = data.assign.isVoiceMail;
              item.bankStatus = data.assign.bankStatus;
              item.isMethadone = data.assign.isMethadone;
              item.notAnswer = data.assign.notAnswer;
              item.badPhoneNumber = data.assign.badPhoneNumber;
              item.isHumanConfirmed = data.assign.isHumanConfirmed;
            }
          });
          this.filterdataList.filter((item) => {
            if (data.assign._id === item._id) {
              item.isReadyForPickup = data.assign.isReadyForPickup;
              item.isVipTrip = data.assign.isVipTrip;
              item.isConfirmedTrip = data.assign.isConfirmedTrip;
              item.isMarkedCancelledTrip = data.assign.isMarkedCancelledTrip;
              item.isVoiceMail = data.assign.isVoiceMail;
              item.bankStatus = data.assign.bankStatus;
              item.isMethadone = data.assign.isMethadone;
              item.notAnswer = data.assign.notAnswer;
              item.badPhoneNumber = data.assign.badPhoneNumber;
              item.isHumanConfirmed = data.assign.isHumanConfirmed;
            }
          });
        } else {
          sweetAlert("Error", data.message, "warning", "OK");
        }
      });

    this.socketService
      .addListener(Events.GET_ASSIGN_TRIP_ETA)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {

        if (data.success) {
          if (this.filterdataList && this.filterdataList.length) {
            const selectedTrip = this.filterdataList.find(
              (x) => x._id === this.selectedTripId
            );
            if (selectedTrip) {
              selectedTrip.loadedMessage = data.message;
            }
          }

          this.selectedTripId = null;
        } else {
          sweetAlert("Error", data.message, "warning", "OK");
        }
      });
  }

  onDateChange(event) {
    this.reset();
    this.skip = 0;
    this.clearTrips();
    // this.todayDate = event.toISOString();
    this.todayDate = [
      event[0].toISOString(),
      event[1].endOf("day").toISOString(),
    ];
    this.getTrips();
  }

  onTimeChange(event) {
    this.reset();
    this.skip = 0;
    this.clearTrips();
    // this.todayDate = event.toISOString();
    this.todayDate = [
      event[0].toISOString(),
      event[1].toISOString(),
    ];
    this.getTrips();
  }

  onResetTime() {
    this.reset();
    this.skip = 0;
    this.clearTrips();

    this.todayDate = [
      moment(this.todayDate[0]).startOf("day").toISOString(),
      moment(this.todayDate[1]).endOf("day").toISOString(),
    ];

    this.getTrips();
  }

  getTimeRestrictions() {
    return { min: moment(this.todayDate[0]).startOf("day").toISOString(), max: moment(this.todayDate[1]).endOf("day").toISOString() }
  }

  setTripFilter(tripType) {
    this.filterTripsByModel();
  }

  claimFile(file) {
    let selectedTripIds;

    if (!this.selectedTrips.length)
      selectedTripIds = this.dataList.map((trip) => trip._id);
    else
      selectedTripIds = this.getSelectedTrips().map((trip) => trip._id)

    let payload = {
      status: this.status,
      _ids: selectedTripIds,
      scheduleTime: this.todayDate,
    };


    if (file === "generateExcelFile") {
      this.assignTripService
        .generateTripsReport(payload)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe((data) => {
          if (data) {
            let name = data.excelName;
            let url = urls.REPORT_SERVER_URL + "/excel/" + name;
            downloadFile(url, "", name);
          }
        });
    } else if (file === "generateItineraryFile") {
      this.assignTripService
        .generateTripsIntineraryReport(payload)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe((data) => {
          if (data) {
            let name = data.excelName;
            let url = urls.REPORT_SERVER_URL + "/excel/" + name;
            downloadFile(url, "", name);
          }
        });
    }
  }

  driverMonitoringReport() {
    let selectedTrip;

    if (!this.selectedTrips.length)
      selectedTrip = this.dataList;
    else
      selectedTrip = this.getSelectedTrips();

    let filterTrips = selectedTrip.filter(trip => trip.driver && trip.job && ["completed", "finished", "cancelled"].includes(trip.status))
    if (filterTrips && filterTrips.length) {
      this.csvService.driverMonitoringReport(filterTrips, this.todayDate, this.timeZone)
    }
  }

  getSelectedTrips() {
    return this.dataList
      .filter((trip) => trip.isSelected);

  }

  group(isNotFromButton?) {
    if (this.filterdataList && this.filterdataList.length) {
      if (!isNotFromButton) {
        this.orderBy =
          this.orderBy === "scheduleTime"
            ? "priorityClient.displayName"
            : "scheduleTime";
      }
      if (this.orderBy === "priorityClient.displayName") {
        this.filterdataList.sort((a, b) =>
          a.priorityClient.displayName.localeCompare(
            b.priorityClient.displayName
          )
        ); // ASC
      } else {
        this.filterdataList.sort(
          (a, b) =>
            <any>new Date(a.scheduleTime) - <any>new Date(b.scheduleTime)
        );
      }
    }
  }


  showActionButtons(idx) {
    this.selectedDropdownIndex = idx;
    this.toggleActionButtons = true;
  }

  closeActionMenu(evt) {
    this.selectedDropdownIndex = -1;
    this.toggleActionButtons = false;
  }

  setPartialEditModal(trip) {
    this.partialEditModalObj = trip;
  }

  setCompanyModalContent(trips, ind?) {
    this.companyAssignModalObj = trips;
    this.secondaryCompType = null;
    if (ind >= 0) {
      this.tripIndex = ind;
    }
    if (this.status === "hanging") {
      this.componentType = "hanging";
    } else if (this.status === "cancelled") {
      this.componentType = "cancelled";
    } else if (this.status === "archived") {
      this.componentType = "archived";
    } else if (this.status === "all") {
      this.componentType = "all";
    } else {
      this.componentType = "unassign";
    }
  }

  setModalContent(trips, type, ind?) {
    if (trips)
      this.assignModalObj = trips;
    else
      this.assignModalObj = this.getSelectedTrips().map((trip) => trip._id);

    this.secondaryCompType = null;
    if (ind >= 0) {
      this.tripIndex = ind;
    }
    if (type === "companyNote") {
      this.componentType = type;
    } else if (type === "dsr") {
      this.specialRate = JSON.parse(JSON.stringify(this.assignModalObj));
      this.componentType = type;
    } else if (type === "Multiple Assign") {
      this.componentType = type;
      this.secondaryCompType = this.status;
    } else {
      if (this.status === "hanging") {
        this.componentType = "hanging";
      } else if (this.status === "cancelled") {
        this.componentType = "cancelled";
      } else if (this.status === "archived") {
        this.componentType = "archived";
      } else if (this.status === "all") {
        this.componentType = "all";
      } else {
        this.componentType = type;
      }
    }
  }

  markTripPaid(assign) {
    sweetAlert(
      "Alert",
      "Are you sure you want to mark this trip paid?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        let params = {
          assignId: assign._id,
        };
        params["bankStatus"] = "paid";
        this.socketService.emit(Events.UPDATE_ASSIGN_TRIP, params);
      }
    });
  }

  tripAssignedResponse(tripStatus: string): void {
    // if (tripStatus === 'Trip Assigned' || tripStatus === 'Trip Un Assigned' || tripStatus === 'All Trips Assigned') {
    //   // sweetAlert('Success', tripStatus, 'success', 'OK');
    // } else if (tripStatus !== null) {
    //   sweetAlert('Error', tripStatus, 'error', 'OK');
    // }
    this.selectedTrips = [];
    this.assignModalObj = null;
    this.companyAssignModalObj = null;
    // this.clearTrips();
    this.skip = 0;
    this.getTrips();
  }

  onCloseModal(evt) {
    // if (evt) {
    this.assignModalObj = null;
    this.companyAssignModalObj = null;
    // }
  }

  verifiedCancelled(trip, ind) {
    sweetAlert(
      "Alert",
      "Are you sure you want to mark this trip?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        this.tripIndex = ind;
        const data = {
          isVerifiedCancelled: !trip.isVerifiedCancelled,
        };
        // this.store.dispatch(new VerifiedCancelledTrip(data, trip._id));
        this.assignTripService
          .verifiedCancelTrip(data, trip._id)
          .pipe(takeUntil(componentDestroyed(this)))
          .subscribe(
            (data) => {
              if (data) {
                let tempInd = -1;
                _.find(this.dataList, (item, i) => {
                  if (item._id === this.filterdataList[this.tripIndex]._id) {
                    tempInd = i;
                    return i;
                  }
                });
                this.filterdataList[this.tripIndex].isVerifiedCancelled =
                  !this.filterdataList[this.tripIndex].isVerifiedCancelled;
                // this.dataList[tempInd].isVerifiedCancelled = !this.dataList[tempInd].isVerifiedCancelled;
                tempInd = -1;
              }
              this.tripIndex = -1;
            },
            (err) => {
              this.tripIndex = -1;
            }
          );
      }
    });
  }

  // Select/Un-Select All & Select Single Trip
  onSelectTrip(trip) {
    if (trip.farmout) {
      return;
    }
    const index = this.selectedTrips.indexOf(trip._id);
    if (index > -1) {
      trip.isSelected = false;
      this.selectedTrips.splice(index, 1);
    } else {
      trip.isSelected = true;
      this.selectedTrips.push(trip._id);
    }
  }

  selectAllTrips() {
    this.filterdataList.forEach((assign) => {
      if (this.status === "cancelled", assign.status === "cancelled" && assign.job && assign.job._id) {
        return;
      }
      if (assign.issues && assign.issues.length) {
        return;
      }
      if (assign.farmout) {
        return;
      }
      assign.isSelected = true;
      if (!this.selectedTrips.includes(assign._id))
        this.selectedTrips.push(assign._id);
    });
    // }

    this.isAllTripsSelected =
      this.selectedTrips.length === this.filterdataList.length;
    return this.isAllTripsSelected;
  }

  filterTripsByModel() {
    this.filterdataList = this.dataList;
    this.filterdataList = new FilterPipe().transform(
      this.filterdataList,
      this.search
    );
    this.filterTrips();
  }

  filterTrips() {
    this.filterdataList = this.filterdataList.filter(trip => {
      let isDriverExist = true;
      let isCorporateExist = true;
      let islosExist = true;
      let isSpaceTypeExist = true;
      let isServiceAreaExist = true;
      let isAptTypeExist = true;
      let isPatientExist = true;
      let isStaffExist = true;
      let isVipMember = true;
      let isManualTrip = true;
      let isMissingLos = true;
      let isMissingAptType = true;
      let isMissingAptTime = true;
      let isMissingAddress = true;
      let isMissingPhone = true;
      let isDuplicateAddress = true;
      let isDuplicateTrip = true;


      if (this.isVipMember) {
        if (trip.isVipTrip) {
          isVipMember = true;
        } else {
          isVipMember = false;
        }
      }

      if (this.isManualTrip) {
        if (!trip.rawId) {
          isManualTrip = true;
        } else {
          isManualTrip = false;
        }
      }

      if (this.isMissingLOS) {
        isMissingLos = this.isTripMissingLOS(trip);
      }

      if (this.isMissingAppointmentType) {
        isMissingAptType = this.isTripMissingAppointmentType(trip);
      }

      if (this.isMissingAppointmentTime) {
        isMissingAptTime = this.isTripMissingAppointmentTime(trip);
      }

      if (this.isMissingAddress) {
        isMissingAddress = this.isTripMissingAddress(trip);
      }

      if (this.isMissingPhone) {
        isMissingPhone = this.isTripMissingPhone(trip);
      }

      if (this.isDuplicateAddress) {
        isDuplicateAddress = this.isTripDuplicateAddress(trip);
      }

      if (this.isDuplicateTrip) {
        isDuplicateTrip = trip.isDuplicateTrip === true;
      }


      if (this.selectedDriver && this.selectedDriver.length) {
        if (trip.driver && trip.driver._id) {
          isDriverExist = this.selectedDriver.includes(trip.driver._id);
        } else {
          isDriverExist = false;
        }
      }
      if (this.selectedStationManager && this.selectedStationManager.length) {
        if (trip.driver && trip.driver.stationManager) {
          isStaffExist = this.selectedStationManager.includes(trip.driver.stationManager);
        } else {
          isStaffExist = false;
        }
      }

      if (this.selectedPatient && this.selectedPatient.length) {
        if (trip.priorityClient && trip.priorityClient.displayName) {
          isPatientExist = this.selectedPatient.includes(trip.priorityClient.displayName);
        } else {
          isPatientExist = false;
        }
      }

      if (this.selectedSpaceType && this.selectedSpaceType.length) {
        if (trip.spaceType) {
          isSpaceTypeExist = this.selectedSpaceType.includes(trip.spaceType);
        } else {
          isSpaceTypeExist = false;
        }
      }

      if (this.selectedAptType && this.selectedAptType.length) {
        if (trip.tripReason) {
          isAptTypeExist = trip.tripReason.some(item => this.selectedAptType.includes(item));
        } else {
          isAptTypeExist = false;
        }
      }

      if (this.selectedCooperate && this.selectedCooperate.length) {
        if (trip.cooperate) {
          isCorporateExist = this.selectedCooperate.includes(trip.cooperate);
        } else {
          isCorporateExist = false;
        }
      }

      if (this.selectedLOS && this.selectedLOS.length) {
        if (trip.los) {
          islosExist = this.selectedLOS.includes(trip.los);
        } else {
          islosExist = false;
        }
      }

      if (this.selectedServiceArea && this.selectedServiceArea.length) {
        if (trip.serviceArea) {
          isServiceAreaExist = this.selectedServiceArea.includes(trip.serviceArea);
        } else {
          isServiceAreaExist = false;
        }
      }

      if (
        isManualTrip &&
        isVipMember &&
        isMissingLos &&
        isMissingAptType &&
        isMissingAptTime &&
        isMissingAddress &&
        isMissingPhone &&
        isDuplicateAddress &&
        isDuplicateTrip &&
        isDriverExist &&
        isStaffExist &&
        isPatientExist &&
        isSpaceTypeExist &&
        isAptTypeExist &&
        isCorporateExist &&
        islosExist &&
        isServiceAreaExist
      ) {
        return true;
      } else {
        return false;
      }
    });
  }

  setTripMissingFlags(trip: any): void {
    if (!trip) {
      return;
    }
    trip.isMissingLOS = this.checkTripMissingLOS(trip);
    trip.isMissingAppointmentType = this.checkTripMissingAppointmentType(trip);
    trip.isMissingAppointmentTime = this.checkTripMissingAppointmentTime(trip);
    trip.isMissingAddress = this.checkTripMissingAddress(trip);
    trip.isMissingPhone = this.checkTripMissingPhone(trip);
    trip.isDuplicateAddress = this.checkTripDuplicateAddress(trip);
  }

  isTripMissingLOS(trip: any): boolean {
    if (trip && typeof trip.isMissingLOS === 'boolean') {
      return trip.isMissingLOS;
    }
    return this.checkTripMissingLOS(trip);
  }

  checkTripMissingLOS(trip: any): boolean {
    return !trip || !trip.los || (typeof trip.los === 'string' && trip.los.trim() === '');
  }

  isTripMissingAppointmentType(trip: any): boolean {
    if (trip && typeof trip.isMissingAppointmentType === 'boolean') {
      return trip.isMissingAppointmentType;
    }
    return this.checkTripMissingAppointmentType(trip);
  }

  checkTripMissingAppointmentType(trip: any): boolean {
    if (!trip || !trip.tripReason) {
      return true;
    }
    if (Array.isArray(trip.tripReason)) {
      if (trip.tripReason.length === 0) {
        return true;
      }
      return !trip.tripReason.some(function(item) {
        return item !== null && item !== undefined && (typeof item !== 'string' || item.trim() !== '');
      });
    }
    if (typeof trip.tripReason === 'string') {
      return trip.tripReason.trim() === '';
    }
    return false;
  }

  isTripMissingAppointmentTime(trip: any): boolean {
    if (trip && typeof trip.isMissingAppointmentTime === 'boolean') {
      return trip.isMissingAppointmentTime;
    }
    return this.checkTripMissingAppointmentTime(trip);
  }

  checkTripMissingAppointmentTime(trip: any): boolean {
    if (!trip || !trip.appointmentTime) {
      return true;
    }
    if (typeof trip.appointmentTime === 'string' && trip.appointmentTime.trim() === '') {
      return true;
    }
    return !moment(trip.appointmentTime).isValid();
  }

  isAddressMissing(address: any, lat?: any, lng?: any): boolean {
    if (!address || (typeof address === 'string' && address.trim() === '')) {
      return true;
    }
    if (lat === null || lat === undefined || lat === '' || lng === null || lng === undefined || lng === '') {
      return true;
    }
    const numLat = Number(lat);
    const numLng = Number(lng);
    if (isNaN(numLat) || isNaN(numLng)) {
      return true;
    }
    if (numLat === 0 && numLng === 0) {
      return true;
    }
    return false;
  }

  isTripMissingAddress(trip: any): boolean {
    if (trip && typeof trip.isMissingAddress === 'boolean') {
      return trip.isMissingAddress;
    }
    return this.checkTripMissingAddress(trip);
  }

  checkTripMissingAddress(trip: any): boolean {
    if (!trip) {
      return true;
    }
    const isPickupMissing = this.isAddressMissing(
      trip.jobOriginAddress,
      trip.jobOriginLatitude,
      trip.jobOriginLongitude
    );
    if (isPickupMissing) {
      return true;
    }
    return this.isAddressMissing(
      trip.jobDestinationAddress,
      trip.jobDestinationLatitude,
      trip.jobDestinationLongitude
    );
  }

  isTripMissingPhone(trip: any): boolean {
    if (trip && typeof trip.isMissingPhone === 'boolean') {
      return trip.isMissingPhone;
    }
    return this.checkTripMissingPhone(trip);
  }

  checkTripMissingPhone(trip: any): boolean {
    const client = trip && trip.priorityClient;
    const isEmpty = (v: any) => v === null || v === undefined || String(v).trim() === '';
    return !client || (isEmpty(client.contactNumber) && isEmpty(client.cellPhone));
  }

  hasValidCoordinates(lat: any, lng: any): boolean {
    if (lat === null || lat === undefined || lat === '' || lng === null || lng === undefined || lng === '') {
      return false;
    }
    const numLat = Number(lat);
    const numLng = Number(lng);
    if (isNaN(numLat) || isNaN(numLng)) {
      return false;
    }
    if (numLat === 0 && numLng === 0) {
      return false;
    }
    return true;
  }

  isTripDuplicateAddress(trip: any): boolean {
    if (trip && typeof trip.isDuplicateAddress === 'boolean') {
      return trip.isDuplicateAddress;
    }
    return this.checkTripDuplicateAddress(trip);
  }

  checkTripDuplicateAddress(trip: any): boolean {
    if (!trip) {
      return false;
    }

    const originAddr = this.normalizeAddress(trip.jobOriginAddress);
    const destAddr = this.normalizeAddress(trip.jobDestinationAddress);

    if (originAddr !== '' && destAddr !== '' && originAddr === destAddr) {
      return true;
    }

    const hasOriginCoords = this.hasValidCoordinates(trip.jobOriginLatitude, trip.jobOriginLongitude);
    const hasDestCoords = this.hasValidCoordinates(trip.jobDestinationLatitude, trip.jobDestinationLongitude);

    if (hasOriginCoords && hasDestCoords) {
      const latDiff = Math.abs(Number(trip.jobOriginLatitude) - Number(trip.jobDestinationLatitude));
      const lngDiff = Math.abs(Number(trip.jobOriginLongitude) - Number(trip.jobDestinationLongitude));
      if (latDiff < 0.0001 && lngDiff < 0.0001) {
        return true;
      }
    }

    return false;
  }

  normalizeAddress(address: any): string {
    return (typeof address === 'string') ? address.trim().toLowerCase() : '';
  }

  // Same member (normalized name), same calendar day in the user's timezone, same pickup and drop-off
  getDuplicateTripKey(trip: any): string {
    if (!trip || !trip.scheduleTime || !trip.priorityClient || !trip.priorityClient.displayName) {
      return '';
    }

    const parsed = parseDisplayName(trip.priorityClient.displayName);
    const memberName = [parsed.firstName, parsed.lastName]
      .filter(Boolean)
      .join(' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
    const originAddr = this.normalizeAddress(trip.jobOriginAddress);
    const destAddr = this.normalizeAddress(trip.jobDestinationAddress);

    if (!memberName || !originAddr || !destAddr) {
      return '';
    }

    const dateKey = moment(trip.scheduleTime).tz(this.timeZone).format('MM/DD/YYYY');
    return [memberName, dateKey, originAddr, destAddr].join('||');
  }

  setDuplicateTripFlags(): void {
    const keys = this.dataList.map((trip) => this.getDuplicateTripKey(trip));
    const counts = {};
    keys.forEach((key) => {
      if (key) {
        counts[key] = (counts[key] || 0) + 1;
      }
    });
    this.dataList.forEach((trip, i) => {
      trip.isDuplicateTrip = !!keys[i] && counts[keys[i]] > 1;
    });
  }

  // Keeps dataList in sync with a trip replaced in filterdataList
  replaceTripInDataList(updatedTrip: any): void {
    const idx = this.dataList.findIndex((t) => t._id === updatedTrip._id);
    if (idx > -1) {
      this.dataList[idx] = updatedTrip;
    }
  }

  removeTripFromDataList(tripId: any): void {
    const idx = this.dataList.findIndex((t) => t._id === tripId);
    if (idx > -1) {
      this.dataList.splice(idx, 1);
    }
  }

  unSelectAllTrips() {
    const unselectedTrips = [];
    this.filterdataList.forEach((trip) => {
      trip.isSelected = false;
      unselectedTrips.push(trip._id);
    });

    this.selectedTrips = this.selectedTrips.filter(x => !unselectedTrips.includes(x));
    this.isAllTripsSelected = false;
  }

  sendMemberText(singleTrip, isMvt) {
    sweetAlert(
      "Alert",
      `Are you sure you want to send ${isMvt ? 'verification' : 'confirmation'} SMS to members?`,
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        if (singleTrip) {
          this.requestConfirmationText([singleTrip._id], isMvt);
        } else {
          const selectedTrips = this.getSelectedTrips().map((trip) => trip._id);
          this.requestConfirmationText(selectedTrips, isMvt);
        }
      }
    });
  }

  requestConfirmationText(selectedTrips, isMvt) {
    let payload = { selectedTrips };
    if (isMvt) {
      payload['isMvt'] = true;
    }
    this.assignTripService
      .sendConfirmationText(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.toastr.success(
            "Text send to members successfully!",
            "Alert"
          );
          // sweetAlert('Success', 'Confirmation text sent to member successfully', 'success', 'OK');
        }
      });
  }

  adjustTrips() {
    const selectedTrips = this.getSelectedTrips().map((trip) => trip._id);
    const payload = { selectedTrips };
    this.assignTripService
      .autoTripAdjustment(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            // sweetAlert('Success', 'Trips adjusted successfully', 'success', 'OK');
          }
        },
        (err) => {
          // this.clearSelection();
        }
      );
  }

  getParseTripList() {
    this.sweepTripsList = [
      {
        _id: "1",
        total: "",
        scraps: [
          {
            _id: "",
            rawId: "",
            created: "",
            type: "",
            company: "",
            jobs: "",
          },
        ],
      },
    ];
    // this.store.dispatch(new GetSweepTripsList());
    this.assignTripService
      .getSweepTripsList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.sweepTripsList = data;
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  // **************** ACTIONS ON TRIP ****************
  // Add Biller Note
  addBillerNote(trip, ind) {
    // this.tripIndex = ind;
    this.billerNoteModalObj = trip;
  }

  onBillerNoteAdded(event) {
    if (event) {
      // sweetAlert('Success', 'Biller Note Added Successfully', 'success', 'OK');
      this.billerNoteModalObj = null;
    } else {
      this.billerNoteModalObj = null;
    }
    // this.assignTripService
    //   .addBillerNote(event)
    //   .subscribe(data => {
    //     if (data) {
    //       let tempInd = -1;
    //         _.find(this.dataList, (item, i) => {
    //           if (item._id === this.filterdataList[this.tripIndex]._id) {
    //             tempInd = i;
    //             return i;
    //           }
    //         });
    //         this.filterdataList[this.tripIndex] = this.assignModalObj;
    //         this.dataList[tempInd] = this.assignModalObj;
    //         this.tripIndex = -1;
    //         tempInd = -1;
    //         this.assignModalObj = null;
    //     }
    //   }, err => {
    //     this.tripIndex = -1;
    //     sweetAlert('Error', err, 'error', 'OK');
    //   });
  }

  // Add Additional Note
  addAdditionalNote(trip, idx) {
    this.additionalNoteModalObj = trip;
  }

  onAdditionalNoteAdded(evt) {
    if (evt) {
      // sweetAlert('Success', 'Additional Note Added Successfully', 'success', 'OK');
    }
    this.additionalNoteModalObj = null;
  }

  // Add Special Rates
  addSpecialRates(data) {
    this.assignTripService
      .addSpecialRate(data)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.dataList.forEach((item, i) => {
              if (item._id === data._id) {
                this.dataList[i].customerSpecialRate = data.customerSpecialRate;
                this.dataList[i].specialRate = data.specialRate;
              }
            });
            this.filterdataList.forEach((item, i) => {
              if (item._id === data._id) {
                this.filterdataList[i].customerSpecialRate =
                  data.customerSpecialRate;
                this.filterdataList[i].specialRate = data.specialRate;
              }
            });
            // sweetAlert('Success', 'Trip Special Rate Added Successfully', 'success', 'OK');
          }
          this.closeActionMenu(null);
        },
        (err) => {
          sweetAlert("Error", err, "warning", "OK");
          this.closeActionMenu(null);
        }
      );
  }

  // Calculate Fare
  calculateFare(assign) {
    this.assignTripService
      .calculateFare(assign._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            assign.estimatedSpecialRate = data.totalFare || "";
            sweetAlert(
              "Alert",
              `Are you sure you want to update BSR Fare: $${data.totalFare} of '${assign.priorityClient.displayName}' - ${assign.tripId}`,
              "warning",
              "Yes",
              "No"
            ).then((result: any) => {
              if (result.value) {
                const payload = {
                  ...data,
                  _id: assign._id
                };
                this.updateDriverFare(payload);
              }
            });


          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  // Add Special Rate
  addSpecialRate() {
    this.addSpecialRates(this.specialRate);
    // $('#dsrModal .close').click();
  }

  // Update Job - Mark Ready, Mark VIP, Mark Confirm, Mark Voicemail
  updateJob(assign, assignKey) {
    let params = {
      assignId: assign._id,
    };
    params[assignKey] = !assign[assignKey];
    this.socketService.emit(Events.UPDATE_ASSIGN_TRIP, params);
  }
  sendForAuth(assign) {
    this.cms1500Service.sendForAuthPDF(assign, this.user);
  }

  // Update Job - Mark Ready, Mark VIP, Mark Confirm, Mark Voicemail
  dropTrip(assign) {
    sweetAlert(
      "Alert",
      "Are you sure you want to drop this trip?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        let params = {
          assignId: assign._id,
          changeReason: "Will Do Later",
          driverId: assign.driver._id,
          company: { _id: this.user._id, displayName: this.user.displayName },
        };
        this.socketService.emit(Events.DROP_TRIP, params);
      }
    });
  }

  // Clone Trip
  cloneTrip(id) {
    sweetAlert(
      "Alert",
      "Are you sure you want to clone this trip?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        this.assignTripService
          .cloneTrip(id)
          .pipe(takeUntil(componentDestroyed(this)))
          .subscribe(
            (data) => {
              if (data) {
                this.getTrips();
                // sweetAlert('Success', 'Trip Cloned Successfully', 'success', 'OK');
              }
            },
            (err) => {
              sweetAlert("Error", err, "error", "OK");
            }
          );
      }
    });

    // const isConfirmed = confirm('Are you sure you want to clone this trip');
    // if (isConfirmed) {
    //   this.assignTripService
    //     .cloneTrip(id)
    //     .subscribe(data => {
    //       if (data) {
    //         sweetAlert('Success', 'Trip Cloned Successfully', 'success', 'OK');
    //       }
    //     }, err => {
    //       sweetAlert('Error', err, 'error', 'OK');
    //     });
    // }
  }

  // Remove Trip
  cancelTrip(trip, isNoShow?) {
    this.cancelTripModalObj = trip;
    if (isNoShow) {
      this.isNoShow = isNoShow;
    }
  }

  onCancelTrip(evt) {
    if (evt) {
      const index = this.filterdataList.findIndex(
        (trip) => trip._id === evt._id
      );
      if (['all', 'cancelled'].includes(this.status)) {
        this.setTripMissingFlags(evt);
        this.filterdataList[index] = evt;
        this.replaceTripInDataList(evt);
      } else {
        this.filterdataList.splice(index, 1);
        this.removeTripFromDataList(evt._id);
      }
      if (evt.effectedTrips && evt.effectedTrips.length) {
        const { effectedTrips } = evt;
        const effectedTripsMapper = effectedTrips.reduce((obj, item) => (obj[item._id] = item, obj), {});
        if (['all', 'cancelled'].includes(this.status)) {
          this.filterdataList.forEach((trip) => {
            if (effectedTripsMapper[trip._id]) {
              Object.keys(effectedTripsMapper[trip._id]).forEach((key) => {
                trip[key] = effectedTripsMapper[trip._id][key];
              });
              this.setTripMissingFlags(trip);
            }
          });
        } else {
          for (let i = this.filterdataList.length - 1; i >= 0; i--) {
            const { _id } = this.filterdataList[i];
            if (effectedTripsMapper[_id]) {
              this.filterdataList.splice(i, 1);
              this.removeTripFromDataList(_id);
            }
          }
        }
      }
      this.setDuplicateTripFlags();
    }
    this.cancelTripModalObj = null;
    this.isNoShow = false;
  }


  updateDriverFare(payload) {
    this.dispatchCenterService
      .saveDriverFare(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.filterdataList.forEach((trip) => {
            if (trip._id === payload._id) {
              trip.preSpecialRate = payload.totalFare || "";
            }
          });
          this.selectedTrip = null;
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  isStringExist(substrings, str) {
    if (substrings.some((v) => str.toLowerCase().includes(v))) {
      return true;
    }
    return false;
  }

  rejectRide(assign, index) {
    sweetAlert(
      "Alert",
      "Are you sure you want to re-route this Trip?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        assign.status = "archived";
        this.assignTripService
          .assignTrip(assign)
          .pipe(takeUntil(componentDestroyed(this)))
          .subscribe((data) => {
            if (data) {
              let findTripIndex = this.filterdataList.findIndex(
                (t) => t._id === assign._id
              );
              this.filterdataList.splice(findTripIndex, 1);
              this.removeTripFromDataList(assign._id);
              this.setDuplicateTripFlags();
              sweetAlert('Success', 'Trip Re-routed Successfully', 'success', 'OK');
            }
          });
      }
    });
  }

  pullBackFarmoutTrip(assign) {
    this.pullBackFarmoutModalObj = assign;
  }

  onPullBackFarmoutTrip(evt) {
    this.pullBackFarmoutModalObj = null;
    if (evt) {
      this.getTrips();
    }
  }

  markCompletedTrip(assign) {
    sweetAlert(
      "Alert",
      "Are you sure you want to complete this trip?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        this.assignTripService
          .markCompletedTrip(assign)
          .pipe(takeUntil(componentDestroyed(this)))
          .subscribe((data) => {
            if (data) {
              let findTripIndex = this.filterdataList.findIndex(
                (t) => t._id === assign._id
              );
              this.filterdataList.splice(findTripIndex, 1);
              this.removeTripFromDataList(assign._id);
              this.setDuplicateTripFlags();
              // sweetAlert('Success', 'Trip marked completed successfully', 'success', 'OK');
            }
          });
      }
    });
  }

  cancelCompleted(assign, index) {
    // adding temprary key to log, we are cancelling this as  Finished cancel trip.
    assign.isFinishedCalled = true;
    this.cancelTripModalObj = assign;
  }

  markDvRequired(assign, index) {
    this.assignTripService
      .updateTrip(assign)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          // sweetAlert('Success', `${assign.isDvRequired ? 'Marked' : 'Un-Marked'} DV Required Successfully`, 'success', 'OK');
        }
      });
  }

  isPaidTrip(assign, index) {
    this.assignTripService
      .updateTrip(assign)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          // sweetAlert('Success', `${assign.takeSignaturesOnly ? 'Marked' : 'Un-Marked'} Is Paid Successfully`, 'success', 'OK');
        }
      });
  }

  showFilter() {
    this.showSlideFilter = !this.showSlideFilter;
  }

  closeFilter() {
    this.showSlideFilter = false;
  }

  viewTripDetails(trip) {
    this.tripDetailModalObj = trip;
  }

  viewCompletedTripDetails(trip) {
    this.completedTripModalObj = trip;
  }

  editTrip(assign) {
    this.editTripModalObj = assign._id;
  }

  onEditTrip(event) {
    if (event) {
      const idx = this.filterdataList.findIndex((t) => t._id === event._id);
      // const index = this.filterdataList.findIndex(event._id);
      if (
        moment(event.appointmentTime).format("YYYY-MM-DD") !==
        moment(this.filterdataList[idx].appointmentTime).format(
          "YYYY-MM-DD"
        ) ||
        moment(event.scheduleTime).format("YYYY-MM-DD") !==
        moment(this.filterdataList[idx].scheduleTime).format("YYYY-MM-DD")
      ) {
        // this.clearTrips();
        // this.getTrips();
        this.filterdataList.splice(idx, 1);
        this.removeTripFromDataList(event._id);
      } else {
        event.isWillcall = moment(event.scheduleTime).tz(this.timeZone).format("HHmm") == '2359';
        this.setTripMissingFlags(event);
        this.filterdataList[idx] = event;
        this.replaceTripInDataList(event);
      }

      if (event.effectedTrips && event.effectedTrips.length) {
        const { effectedTrips } = event;
        const effectedTripsMapper = effectedTrips.reduce((obj, item) => (obj[item._id] = item, obj), {});
        this.filterdataList.forEach((trip) => {
          if (effectedTripsMapper[trip._id]) {
            Object.keys(effectedTripsMapper[trip._id]).forEach((key) => {
              trip[key] = effectedTripsMapper[trip._id][key];
            });
            this.setTripMissingFlags(trip);
          }
        });
      }
      this.setDuplicateTripFlags();
      this.editTripModalObj = null;
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.settingInterval);
    this.socketService.removeListener(Events.UPDATE_ASSIGN_TRIP);
    this.sharedDataService.toggleDatePicker(false);
  }

  loadedMiles(trip) {
    this.selectedTripId = trip._id;
    const payload = {
      assignId: trip._id,
      isDriveTime: true,
    };
    this.socketService.emit(Events.GET_ASSIGN_TRIP_ETA, payload);
  }

  getStaffRoles() {
    this.refreshStatusMenus();

    if (this.subMenus && this.subMenus.length) {
      if (this.subMenus[0].value === "all" && this.subMenus.length > 1)
        this.status = this.subMenus[2].value;
      else this.status = this.subMenus[0].value;

      this.getTrips();
    }
  }

  private refreshStatusMenus() {
    if (!(this.user && this.user.roles)) {
      return;
    }
    if (typeof this.user.roles === "string") {
      if (this.user.sRoles)
        this.subMenus = this.menuService.getAssignedSubMenu(this.user.sRoles);
      else
        this.subMenus = this.menuService.getAssignedSubMenu(this.user.roles);
    } else if (typeof this.user.roles === "object") {
      this.subMenus = this.menuService.getAssignedSubMenu(this.user.roles[0]);
    }
  }

  onClearDriver() {
    this.selectedDriver = "";
  }
  onClearCooperate() {
    this.selectedCooperate = "";
  }

  onClearTripPurpose() {
    this.selectedTripPurpose = "";
  }

  onTimerComplete(): void {
    this.timer.init();
    // this.clearTrips();
    this.skip = 0;
    this.getTrips();
  }


  downloadDriverReport() {
    let trips;

    if (!this.selectedTrips.length)
      trips = this.dataList;
    else
      trips = this.getSelectedTrips();


    const data = {
      date:
        moment(this.todayDate[0]).format("MM/DD/YYYY") +
        " - " +
        moment(this.todayDate[1]).format("MM/DD/YYYY"),
      trips,
      corporate: this.selectedCooperate,
      driver: this.selectedDriver,
      // vehicle: this.selectedVehicle,
      timezone: this.timeZone,
    };
    this.csvService.generateDriverReport(data);
  }

  corporateReport() {
    let trips;

    if (this.status === 'all' || !this.selectedTrips.length)
      trips = this.dataList;
    else
      trips = this.getSelectedTrips();

    const data = {
      trips,
      corporate: this.selectedCooperate,
      driver: this.selectedDriver,
      // vehicle: this.selectedVehicle,
      timezone: this.timeZone,
    };
    this.csvService.generateCorporateReport(data);
  }

  trackByFn(index, item) {
    if (!item) return;
    return item._id; // index or item.id
  }

  toggleTimer() {
    this.isTimerEnabled = !this.isTimerEnabled;
    if (this.isTimerEnabled) {
      this.skip = 0;
      this.getTrips();
    } else {
      this.timer.init();
    }
  }

  getCmsReport(trip) {
    let queryParams = {
      companyType: trip.companyType,
      tripIdentity: trip.tripIdentity,
      type: "triplogs",
    };
    if (trip.cooperate) {
      queryParams["cooperate"] = trip.cooperate._id;
    }
    this.cms1500Service.getCmsReport(queryParams, this.user);
  }


  markRead(assign) {
    if (assign.viewStatus === "returned") return;
    sweetAlert(
      "Alert",
      "Are you sure you want to mark this trip as acknowledged?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        assign.viewStatus = "";
        assign.dispatchNoteTwo += ` Mark Acknowledged : ${this.user.displayName
          } ${moment().tz(`${this.timeZone}`).format("MM/DD/YY HHmm")}`;
        this.assignTripService
          .assignTrip(assign)
          .pipe(takeUntil(componentDestroyed(this)))
          .subscribe((data) => {
            if (data) {
              // sweetAlert('Success', 'Ride Re-routed Successfully', 'success', 'OK');
              this.closeActionMenu(null);
            }
          });
      }
    });
  }

  // updatedJobFee(evt) {
  //   if (this.filterdataList && this.filterdataList.length) {
  //     const selectedTrip = this.filterdataList.find(
  //       (x) => x.job._id === evt.tripId
  //     );
  //     if (
  //       selectedTrip &&
  //       selectedTrip.job &&
  //       selectedTrip.job.driverFareDetail
  //     ) {
  //       selectedTrip.job.driverFareDetail.jobFee = evt.jobFee;
  //     }
  //   }
  // }

  updatedAssociateImg(evt) {
    if (this.filterdataList && this.filterdataList.length) {
      const selectedTrip = this.filterdataList.find(
        (x) => x._id === evt.tripId
      );
      if (selectedTrip) {
        selectedTrip.associateImage = evt.associateImage;
        selectedTrip.associateImageType = evt.associateImageType;
      }
    }
  }

  updatedCompImg(evt) {
    if (this.filterdataList && this.filterdataList.length) {
      const selectedTrip = this.filterdataList.find(
        (x) => x.job._id === evt.jobId
      );
      if (selectedTrip) {
        selectedTrip.associateImage = evt.associateImage;
        selectedTrip.associateImageType = evt.associateImageType;
      }
    }
  }

  updateTripData(evt) {
    if (this.filterdataList && this.filterdataList.length) {
      const selectedTrip = this.filterdataList.find((x) => x._id === evt._id);
      if (selectedTrip) {
        selectedTrip.attachment = evt.attachment;
        selectedTrip.companyNote = evt.companyNote;
        selectedTrip.dispatchNoteTwo = evt.dispatchNoteTwo;
      }
    }
  }

  attachAssociateImg(trip) {
    this.associateImageModalObj = trip;
  }

  driverGrivenceReport(trip) {
    this.reportService.getDriverGrivenceReport(trip, this.user);
  }

  adjustCompletedTrips() {
    sweetAlert(
      "Alert",
      `Are you sure you want to adjust the trips?`,
      "warning",
      "Yes",
      "No"
    ).then((result) => {
      if (result.value) {
        const selectedTrips = this.getSelectedTrips().map((trip) => trip._id);
        const payload = {
          scheduleTime: this.todayDate.toString(),
          selectedTrips
        };
        this.assignTripService
          .adjustCompletedTrips(payload)
          .subscribe((data) => {
            if (data && data.success) {
              if (data.jobIds && data.jobIds.length) {
                this.filterdataList.forEach((trip) => {
                  if (
                    trip.job &&
                    trip.job._id &&
                    data.jobIds.includes(trip.job._id)
                  ) {
                    trip.job.isFareAdjusted = true;
                  }
                });
              }
              this.toastr.success(data.message, "Alert");
            }
          });
      }
    });
  }

  getETA(trip) {
    this.assignTripService
      .getETA(trip._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          trip.etaMessage = data.etaMessage;
        }
      });
  }

  openTripLog(assign) {
    this.tripLogObj = assign;
  }
  checkListModal(assign) {
    this.checkListObj = assign;
  }

  openAiAssistantConversation(assign) {
    this.aiAssistantConversationObj = assign;
  }

  tripConfirmationReport() {
    let selectedTripIds;

    if (!this.selectedTrips.length) {
      selectedTripIds = this.dataList.map((trip) => trip._id);
    }
    else {
      selectedTripIds = this.getSelectedTrips().map((trip) => trip._id)
    }

    const payload = {
      _ids: selectedTripIds
    }
    this.assignTripService.downloadConfirmationReport(payload).subscribe(data => {
      if (data) {
        let name = data.excelName;
        let url = urls.REPORT_SERVER_URL + '/excel/' + name;
        downloadFile(url, '', name);
      }
    });
  }

  isOver48Hours(createdAt): boolean {
    const createdTime = moment(createdAt);
    const currentTime = moment();
    const differenceInHours = currentTime.diff(createdTime, 'hours');
    return differenceInHours > 48;
  }


  getAssisData() {
    this.assistService.getAllAssists()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.assists = data;
          this.preAssistList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});

        }
      });
  }

  openTemplateSaveModal() {
    let driverMembers = {};
    this.filterdataList.forEach(trip => {
      if (trip.driver) {
        const driver = trip.driver;
        const member = trip.priorityClient;
        if (driverMembers[driver._id]) {
          const storedMemebers = driverMembers[driver._id].members;
          driverMembers[driver._id] = {
            driver: driver,
            members: [...storedMemebers, { _id: trip.client, ...member }]
          }
        } else {
          driverMembers[driver._id] = {
            driver: driver,
            members: [{ _id: trip.client, ...member }]
          }
        }
      }
    });

    const template = [];
    Object.keys(driverMembers).forEach(driverId => {
      let { driver, members } = driverMembers[driverId]
      members = _.uniq(members, '_id').sort();
      template.push({ driver, members });
    })
    this.templateSaveModalObj = template;
  }


  sendToIPCR(payload) {
    let attendee
    let spaceType = null;
    if (payload.spaceType && this.preSpaceTypes[payload.spaceType]) {
      const { _id, title } = this.preSpaceTypes[payload.spaceType]
      spaceType = {
        _id,
        title
      }
    }
    if (payload.attendees) {
      for (let item of payload.attendees) {
        attendee = this.preAssistList[item]
      }
    }
    const object = {
      _id: payload._id,
      createdAt: payload.createdAt,
      attendee,
      scheduleTime: payload.scheduleTime,
      appointmentTime: payload.appointmentTime,
      client: payload.client,
      jobOriginAddress: payload.jobOriginAddress,
      jobDestinationAddress: payload.jobDestinationAddress,
      tripId: payload.tripId,
      spaceType,
      companyNote: payload.companyNote
    }
    this.assignTripService.sendToIPCR(object).subscribe((data) => {
      if (data) {

      }
    })
  }

  feedback(trip) {
    this.feedbackTrip = trip;
  }

  openWillCallModal(trip) {
    this.willCallObj = trip;
  }

  closeWillCallModal(event) {
    if (event) {
      const idx = this.filterdataList.findIndex((t) => t._id === event._id);
      this.setTripMissingFlags(event);
      this.filterdataList[idx] = event;
      this.replaceTripInDataList(event);
      this.setDuplicateTripFlags();
    }
    this.willCallObj = null;
  }


  filterVipMembers() {
    this.filterTripsByModel();
  }

  filterManualTrip() {
    this.filterTripsByModel();
  }



  sendBulkTripConfirmation() {
    sweetAlert(
      "Alert",
      "Are you sure you want to send confirmation SMS to members?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        const payload = {
          startDate: this.todayDate[0],
          endDate: this.todayDate[1]
        }
        this.assignTripService
          .sendBulkTripConfirmation(payload)
          .pipe(takeUntil(componentDestroyed(this)))
          .subscribe(data => {
          }, err => {
            sweetAlert('Error', err, 'warning', 'OK');
          });
      }
    });
  }

  openEditIntakeModal(trip) {
    this.tripIntakeModalObj = trip;
  }

  closeTripIntakeModal(evt) {
    if (evt) {
      if (this.filterdataList && this.filterdataList.length) {
        const selectedTrip = this.filterdataList.find((x) => x._id === evt._id);
        if (selectedTrip) {
          selectedTrip.intakeSuggestedTime = evt.intakeSuggestedTime;
        }
      }
    }
    this.tripIntakeModalObj = null;
  }


  async unConfirmIntake(trip) {
    const confirm = await sweetAlert(
      "Alert!",
      `Are you sure you want to unconfirm this trip?`,
      "warning",
      "Yes",
      "No"
    );
    if (confirm.value) {
      this.updateIntakeStatus(trip, "unconfirmed");
    }
  }

  async confirmIntake(trip) {
    const confirm = await sweetAlert(
      "Alert!",
      `Are you sure you want to confirm this trip?`,
      "warning",
      "Yes",
      "No"
    );
    if (confirm.value) {
      this.updateIntakeStatus(trip, "confirmed");
    }
  }

  updateIntakeStatus(trip, intakeStatus) {
    const payload = {
      _id: trip._id,
      intakeStatus
    }
    this.assignTripService
      .updateTrip(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          trip.intakeStatus = data.intakeStatus
          if (intakeStatus === 'confirmed') {
            const idx_main = this.dataList.findIndex((trip) => trip._id === data._id);
            this.dataList.splice(idx_main, 1);
            const idx_filter = this.filterdataList.findIndex((trip) => trip._id === data._id);
            this.filterdataList.splice(idx_filter, 1);
            this.setDuplicateTripFlags();
          }
        }
      });
  }

  getPayorList() {

    const param = {
      status: 'active'
    };

    this.payorService
      .getPayorList(param)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data: any) => {
          if (data) {
            this.payorList = data;
            this.prePayorsList = this.payorList.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert('Error', err, 'warning', 'OK');
        }
      );
  }

  sendMemberCall(singleTrip:any) {
    sweetAlert(
      "Alert",
      `Are you sure you want to send confirmation Call to member?`,
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        if (singleTrip) {
          this.requestConfirmationCall(singleTrip);
        }
      }
    });
  }

  requestConfirmationCall(selectedTrips:any) {
    if (!this.outBoundNumber) {
      this.toastr.error("Outbound number not available!", "Alert");
      return;
    }

    const memberName = selectedTrips.priorityClient && selectedTrips.priorityClient.displayName;
    const to = selectedTrips.priorityClient && selectedTrips.priorityClient.contactNumber;
    const client = selectedTrips.client;
    const pickup = selectedTrips.jobOriginAddress;
    const dropoff = selectedTrips.jobDestinationAddress;

    const isPickupTimeValid = selectedTrips.scheduleTime && moment(selectedTrips.scheduleTime).isValid();
    const pickupTime = isPickupTimeValid
      ? moment(selectedTrips.scheduleTime).tz(this.timeZone).format("MMMM D, YYYY h:mm A")
      : "";

    const currentDateTime = moment().tz(this.timeZone).format("YYYY-MM-DD HH:mm:ss");
    const from = this.outBoundNumber;
    const spaceType = this.preSpaceTypes[selectedTrips.spaceType] && this.preSpaceTypes[selectedTrips.spaceType].title;

    const isAppointmentTimeValid = selectedTrips.appointmentTime && moment(selectedTrips.appointmentTime).isValid();
    const appointmentTime = isAppointmentTimeValid
      ? moment(selectedTrips.appointmentTime).tz(this.timeZone).format("MMMM D, YYYY h:mm A")
      : "";

    const missingFields = [];
    if (!memberName) missingFields.push('Member Name');
    if (!to) missingFields.push('Contact Number');
    if (!pickup) missingFields.push('Pickup Address');
    if (!dropoff) missingFields.push('Dropoff Address');
    if (!pickupTime) missingFields.push('Pickup Time');
    if (!appointmentTime) missingFields.push('Dropoff Time');
    if (!spaceType) missingFields.push('Space Type');

    if (missingFields.length > 0) {
      sweetAlert(
        "Alert!",
        `This trip has missing details: ${missingFields.join(', ')}.`,
        "warning",
        "OK"
      );
      return;
    }

    let payload = {
      "_id": selectedTrips._id,
      "memberName": memberName,
      "to": to,
      "client": client,
      "pickup": pickup,
      "dropoff": dropoff,
      "pickupTime": pickupTime,
      "currentDateTime": currentDateTime,
      "from": from,
      "spaceType": spaceType,
      "appointmentTime": appointmentTime,
    };

    this.assignTripService
      .sendConfirmationCall(payload,this.confirmationCallURL)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.toastr.success(
            "Call send to member successfully!",
            "Alert"
          );
        }
      });
  }

  isTodayOrFuture(scheduleTime: string): boolean {
    const tripDate = moment.tz(scheduleTime, this.timeZone).startOf('day');
    const today = moment.tz(this.timeZone).startOf('day');

    return tripDate.isSameOrAfter(today);
  }

  async openBulkConfirmationCallModal() {
    if (!this.outBoundNumber) {
      this.toastr.error("Outbound number not available!", "Alert");
      return;
    }
    const grouped = await this.groupMemberTrips();
    if (!grouped) {
      return;
    }
    this.bulkCallReviewGroups = JSON.parse(JSON.stringify(grouped));
  }

  async groupMemberTrips() {
    let selectedTrips = this.getSelectedTrips();
    if (this.status === 'all') {
      const eligibleTrips = this.getEligibleTripsForBulkConfirmation(selectedTrips);
      if (eligibleTrips && eligibleTrips.length) {
        selectedTrips = eligibleTrips;  
      } else {
        sweetAlert('Alert', 'Selected trips are not eligible for confirmation call.', 'warning', 'OK');
        return;
      }
    }
    const trips = selectedTrips;
    const memberIds = _.uniq(trips.map((trip: any) => trip.client).filter(client => client));
    let tripsMembers;
    try {
      tripsMembers = await this.getMembersByIds(memberIds);
    } catch (error) {
      tripsMembers = [];
    }
    const tripsMembersMap = (tripsMembers && Array.isArray(tripsMembers))
      ? tripsMembers.reduce((obj, item) => (obj[item._id] = item, obj), {})
      : ((tripsMembers && tripsMembers.data && Array.isArray(tripsMembers.data))
        ? tripsMembers.data.reduce((obj, item) => (obj[item._id] = item, obj), {})
        : {});

    const groupedTrips = this.groupAndSortTripsV3(trips, tripsMembersMap);
    return groupedTrips;
  }

  getEligibleTripsForBulkConfirmation(trips: any) {
    // only be called if All tab is selected
    return trips.filter((trip: any) => {
      const isTripEligible = ['unassigned', 'offered', 'accepted'].includes(trip.status);
      return isTripEligible;
    });
  }

  async getMembersByIds(ids: any) {
    if (!ids || ids.length === 0) return [];
    const payload = {
      accountStatus: 'active',
      _ids: ids
    };
    const members = await this.assignTripService.getClients(payload).toPromise();
    return members;
  }

  groupAndSortTripsV3(trips, membersMap) {
    const userTimeZone = this.timeZone || (this.user && this.user.timeZone) || moment.tz.guess();
    const grouped = trips.reduce(function (acc, trip) {
      const member = trip && trip.client ? membersMap[trip.client] : null;
      const displayName = (trip && trip.priorityClient && trip.priorityClient.displayName) ||
                          (member && (member.displayName || ((member.firstName || '') + ' ' + (member.lastName || '')).trim()));
      if (!trip || !displayName) return acc;

      let firstName = '';
      let lastName = '';
      if (member && (member.firstName || member.lastName)) {
        firstName = member.firstName || '';
        lastName = member.lastName || '';
      } else {
        const parsed = parseDisplayName((member && member.displayName) || displayName);
        firstName = parsed.firstName || '';
        lastName = parsed.lastName || '';
      }

      const fullName = [firstName, lastName]
        .filter(Boolean)
        .join(' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();

      if (!fullName) return acc;

      if (!acc[fullName]) {
        acc[fullName] = [];
      }

      acc[fullName].push(trip);
      return acc;
    }, {} as Record<string, any[]>);

    // Convert grouped object to array, sort members alphabetically, and sort trips within each member
    const result = Object.keys(grouped)
      .sort((a, b) => {
        const getLastName = (name: string) => {
          const parts = name.split(' ');
          let lastName = '';
          if (parts.length === 2) {
            lastName = parts[parts.length - 1];
          } else if (parts.length > 2) {
            lastName = parts[1];
          }
          return lastName || '';
        };
        const lastA = getLastName(a);
        const lastB = getLastName(b);

        const lastCompare = lastA.localeCompare(lastB);
        if (lastCompare !== 0) return lastCompare;

        // fallback → full name compare
        return a.localeCompare(b);
      })
      .map((member) => {
        const legs = grouped[member];

        // Group trips by pickup date for this member
        const groupedByDate = legs.reduce((dateAcc, trip) => {
          if (!trip.scheduleTime) return dateAcc;

          const scheduleMoment = moment(trip.scheduleTime);
          if (!scheduleMoment.isValid()) return dateAcc;

          const dateKey = scheduleMoment.tz(userTimeZone).format('MM/DD/YYYY');

          if (!dateAcc[dateKey]) {
            dateAcc[dateKey] = [];
          }

          dateAcc[dateKey].push(trip);

          return dateAcc;
        }, {} as Record<string, any[]>);

        // Convert date groups to sorted array
        const dates = Object.keys(groupedByDate)
          .sort((a, b) => moment(a).diff(moment(b))) // sort dates ascending
          .map(date => {
            const legs = groupedByDate[date];

            // sort trips inside each date by pickup time
            legs.sort((a, b) => {
              const dateA = a.scheduleTime ? moment(a.scheduleTime) : moment('9999-12-31');
              const dateB = b.scheduleTime ? moment(b.scheduleTime) : moment('9999-12-31');
              return dateA.diff(dateB);
            });

            return {
              date,
              legs
            };
          });

        return {
          member,
          dates
        };
      });

    return result;
  }

   handleBulkCallSave(trips) {
    this.requestBulkConfirmationCall(trips);
    this.bulkCallReviewGroups = null;
  }

  get lookupData() {
    return { spaceTypes: this.preSpaceTypes, cooperates: this.preCooperates };
  }

  requestBulkConfirmationCall(selectedTrip: any[]) {
    const isEligibleTrip = (trip: any) => !(trip.isConfirmedTrip || trip.isReadyForPickup || trip.isMarkedCancelledTrip || trip.isHumanConfirmed || trip.isVoiceMail || trip.badPhoneNumber) && this.isTodayOrFuture(trip.scheduleTime);

    const eligibileLegsOfSkippedTrips: any[] = [];

    const filteredTrips = selectedTrip.filter((trip: any) => {
      if (isEligibleTrip(trip)) {
        if (trip.legs && trip.legs.length) {
          trip.legs = trip.legs.filter((leg: any) => isEligibleTrip(leg));
        }
        return true;
      }

      if (trip.legs && trip.legs.length) {
        eligibileLegsOfSkippedTrips.push(...trip.legs.filter((leg: any) => isEligibleTrip(leg)));
      }

      return false;
    });

    const tripsToProcess = [...filteredTrips, ...eligibileLegsOfSkippedTrips];

    if (!tripsToProcess.length) {
      return;
    }

    const eligibleTrips = [];
    const tripsWithIssues = [];

    tripsToProcess.forEach(trip => {
      const memberName = trip.priorityClient && trip.priorityClient.displayName;
      const to = trip.priorityClient && trip.priorityClient.contactNumber;
      const client = trip.client;
      const pickup = trip.jobOriginAddress;
      const dropoff = trip.jobDestinationAddress;

      const isPickupTimeValid = trip.scheduleTime && moment(trip.scheduleTime).isValid();
      const pickupTime = isPickupTimeValid
        ? moment(trip.scheduleTime).tz(this.timeZone).format("MMMM D, YYYY h:mm A")
        : "";

      const currentDateTime = moment().tz(this.timeZone).format("YYYY-MM-DD HH:mm:ss");
      const from = this.outBoundNumber;
      const spaceType = this.preSpaceTypes[trip.spaceType] && this.preSpaceTypes[trip.spaceType].title;

      const isAppointmentTimeValid = trip.appointmentTime && moment(trip.appointmentTime).isValid();
      const appointmentTime = isAppointmentTimeValid
        ? moment(trip.appointmentTime).tz(this.timeZone).format("MMMM D, YYYY h:mm A")
        : "";

      const tripData: any = {
        _id: trip._id,
        memberName,
        to,
        client,
        pickup,
        dropoff,
        pickupTime,
        currentDateTime,
        from,
        spaceType,
        appointmentTime
      };

      if (trip.legs && trip.legs.length) {
        tripData['legs'] = trip.legs.map((leg: any) => leg._id);
      }

      const missingFields = [];
      if (!memberName) missingFields.push('Member Name');
      if (!to) missingFields.push('Contact Number');

      if (!pickup) missingFields.push('Pickup Address');
      if (!dropoff) missingFields.push('Dropoff Address');

      if (!pickupTime) missingFields.push('Pickup Time');
      if (!appointmentTime) missingFields.push('Dropoff Time');
      if (!spaceType) missingFields.push('Space Type');

      if (missingFields.length > 0) {
        tripsWithIssues.push({
          ...tripData,
          tripId: trip.tripId,
          issues: missingFields.join(', ')
        });
      } else {
        eligibleTrips.push(tripData);
      }
    });

    (window as any).copyAllTripIssues = () => this.copyAllTripIssues(tripsWithIssues);

    if (tripsWithIssues.length) {
      const message = eligibleTrips.length > 0
        ? `${tripsWithIssues.length} trip(s) have missing details and were not processed. The remaining ${eligibleTrips.length} trip(s) are being processed.`
        : `${tripsWithIssues.length} trip(s) have missing details and were not processed.`;

      let tableHtml = `
        <p class="mb-3 text-slate-600 font-sans text-center" style="font-size: 13px;">
          ${message}
        </p>
        <div class="mt-4 rounded-lg border border-slate-200 shadow-sm" style="max-height: 250px; overflow-y: auto; display: block;">
          <table class="w-full border-collapse font-sans text-left bg-white" style="font-size: 12px;">
            <thead>
              <tr class="bg-slate-50 border-b-2 border-slate-200">
                <th class="p-2.5 font-semibold text-slate-600 uppercase tracking-wider whitespace-nowrap" style="font-size: 10px; width: 45%;">
                  <span style="display: inline-flex; align-items: center; gap: 6px;">
                    MEMBER / ID
                    <button onclick="window.copyAllTripIssues()" class="hover:bg-slate-200" style="display: inline-flex; align-items: center; justify-content: center; padding: 2px; color: #6B7280; background-color: #F1F5F9; border: 1px solid #E2E8F0; border-radius: 4px; cursor: pointer; transition: all 0.2s; outline: none;" title="Copy all details to clipboard">
                      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>
                    </button>
                  </span>
                </th>
                <th class="p-2.5 font-semibold text-slate-600 uppercase tracking-wider" style="font-size: 10px;">Issues</th>
              </tr>
            </thead>
            <tbody>
      `;

      tripsWithIssues.forEach(t => {
        tableHtml += `
          <tr class="border-b border-slate-100">
            <td class="py-2 px-2.5 align-top whitespace-nowrap">
              ${t.memberName ? `<div class="text-[11px] text-gray-400 font-normal leading-tight">${t.memberName}</div>` : ''}
              <div class="font-semibold text-gray-500 text-[12px] mt-0.5">${t.tripId || 'N/A'}</div>
            </td>
            <td class="py-2 px-2.5 text-gray-500 align-top font-normal">${t.issues}</td>
          </tr>
        `;
      });

      tableHtml += `
            </tbody>
          </table>
        </div>
      `;

      sweetAlertWithHtml(
        "Alert!",
        "",
        "warning",
        "OK",
        tableHtml
      );
    }

    if (!eligibleTrips.length) {
      return;
    }

    const payload = {
      trips: eligibleTrips
    };

    this.assignTripService
      .sendBulkConfirmationCall(payload, this.confirmationCallURL)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.toastr.success(
            "Call send to member successfully!",
            "Alert"
          );
        }
      });
  }

  copyAllTripIssues(tripsWithIssues:any) {
    const textToCopy = tripsWithIssues.map(t => `Trip ID: ${t.tripId || 'N/A'}\nIssues: ${t.issues}`).join('\n\n');
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(textToCopy).then(() => {
        this.toastr.success('Copied to clipboard!', 'Alert');
      });
    } else {
      const textArea = document.createElement("textarea");
      textArea.value = textToCopy;
      textArea.style.position = "fixed";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        this.toastr.success('Copied all trip issues to clipboard!', 'Alert');
      } catch (err) {
        console.error('Fallback copy failed', err);
      }
      document.body.removeChild(textArea);
    }
  }

}
